import { render, staticRenderFns } from "./WithdrawalApproval.vue?vue&type=template&id=60ac5a20&scoped=true&"
import script from "./WithdrawalApproval.vue?vue&type=script&lang=js&"
export * from "./WithdrawalApproval.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalApproval.vue?vue&type=style&index=0&id=60ac5a20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ac5a20",
  null
  
)

export default component.exports